export default __webpack_public_path__ + "static/media/frame.b3ddb7d5.png";